import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Activity, Stethoscope, Scissors, FlaskConical, Ribbon, FileText, Video, Menu, X } from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/symptoms', icon: Activity, label: 'Symptoms' },
    { path: '/conditions', icon: Stethoscope, label: 'Conditions' },
    { path: '/procedures', icon: Scissors, label: 'Procedures' },
    { path: '/tests', icon: FlaskConical, label: 'Tests' },
    { path: '/cancers', icon: Ribbon, label: 'Cancers' },
    { path: '/after-visit', icon: FileText, label: 'After Visit' },
    { path: '/videos', icon: Video, label: 'Videos' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="main-nav">
      <div className="nav-inner">
        {/* Desktop Navigation */}
        <div className="nav-desktop">
          {navItems.map((item) => (
            <Link 
              key={item.path} 
              to={item.path} 
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <span>{item.label}</span>
            </Link>
          ))}
        </div>

        {/* Mobile Navigation Toggle */}
        <button 
          className="mobile-nav-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <>
            <div 
              className="mobile-nav-overlay"
              onClick={() => setMobileMenuOpen(false)}
            />
            <div className="mobile-nav-menu" data-testid="mobile-nav-menu">
              {navItems.map((item) => (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  className={`mobile-nav-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-${item.label.toLowerCase().replace(' ', '-')}`}
                >
                  <item.icon size={20} />
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
